import styles from './SectionTitle.module.css';

type SectionTitleDividerProps = {
  side: 'left' | 'right';
};

export const SectionTitleDivider = ({ side }: SectionTitleDividerProps) => {
  return (
    <div
      className={`${styles.sectionTitleDivider} ${side === 'left' ? styles.sectionTitleDividerLeft : styles.sectionTitleDividerRight}`}
    />
  );
};
